<template>
  <div id="Authentication">
    <div class="content1">
      <p class="title">认证申请处理<el-button class="invite " size="small" @click="inviteSend" type="primary">邀请后台用户</el-button></p>
      <p class="line-gray"></p>
      <el-form ref="form" :model="form" class="rzForm">
        <el-form-item label="手机号：">
          <el-input size="small" placeholder="请输入手机号" class="input-rz" v-model="form.username"></el-input>
        </el-form-item>
        <el-form-item label="企业名称：">
          <el-input size="small" placeholder="请输入企业名称" class="input-rz" v-model="form.qymc"></el-input>
        </el-form-item>
        <el-form-item label="社会信用代码：">
          <el-input size="small" placeholder="请输入" class="input-rz" v-model="form.nsrsbh"></el-input>
        </el-form-item>
        <el-form-item label="资质等级：">
          <el-select size="small" class="input-rz" v-model="form.zzdj" placeholder="请选择">
            <el-option label="" value="">请选择</el-option>
            <el-option label="A级" value="1"></el-option>
            <el-option label="AA级" value="2"></el-option>
            <el-option label="AAA级" value="3"></el-option>
            <el-option label="AAAA级" value="4"></el-option>
            <el-option label="AAAAA级" value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" class="rzSearch" type="warning" @click="searchSubmit(1)">查询</el-button>
        </el-form-item>
        <el-form-item label="认证状态：">
          <el-radio-group v-model="form.rzzt">
            <el-radio label="" value="">全部</el-radio>
            <el-radio label="1" value="1">待认证</el-radio>
            <!--<el-radio label="2" value="2">已认证</el-radio>-->
            <!--<el-radio label="3" value="3">需正式授权</el-radio>-->
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="rzData">
        <template>
          <el-table
            :data="tableData"
            v-loading="loading"
            height="100%"
            header-row-class-name="head-center"
            border
            style="width: 100%">
            <el-table-column
              prop="Zsxm"
              label="申请人"
              align="center"
              :show-overflow-tooltip="true"
              width="140"
            >
            </el-table-column>
            <el-table-column
              prop="username"
              label="申请人手机号"
              :show-overflow-tooltip="true"
              width="140">
              <!--<template slot-scope="scope">
                <el-popover trigger="hover" placement="top">
                  <p>手机号: {{ scope.row.username }}</p>
                  <div slot="reference" class="name-wrapper text-over">
                    {{ scope.row.username }}
                  </div>
                </el-popover>
              </template>-->
            </el-table-column>
            <el-table-column
              prop="qymc"
              label="企业名称"
              width="160"
              :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
              prop="nsrsbh"
              label="社会信用代码"
              width="116"
              :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
              prop="zzdj"
              label="资质等级"
              align="center"
              :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
              prop="yyzhzhfj"
              label="营业执照附件"
              width="105"
              align="center"
              :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <a class="Brand" v-show="scope.row.yyzhzhfj!=0&&scope.row.yyzhzhfj!=null" href="javascript:;" @click="getPiclist(0,scope.row)">{{ scope.row.yyzhzhfj}}</a>
              </template>
            </el-table-column>
            <el-table-column
              prop="htbh"
              label="合同编号"
              :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
              prop="htbhfj"
              label="合同附件"
              align="center"
              :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <a class="Brand"  v-show="scope.row.htbhfj!=0&&scope.row.htbhfj!=null" href="javascript:;" @click="getPiclist(1,scope.row)">
                  {{ scope.row.htbhfj}}
                </a>
              </template>

            </el-table-column>
            <el-table-column
              prop="days"
              label="等待时长"
              :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
              prop="yxend_time"
              label="有效结束时间"
              width="135"
              :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
              prop="rzztmc"
              align="center"
              label="认证状态"
              width="125"
              :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span v-bind:class="{'Danger':scope.row.rzztmc==='待认证'}">{{ scope.row.rzztmc }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="cz"
              fixed="right"
              label="操作"
              width="140">
              <template slot-scope="scope">
                <el-row>
                  <el-col v-show="scope.row.rzzt==='1'" :span="12"><a href="javascript:;" class="Brand" @click="changeRight('授权',scope.row,scope.$index)">授权</a></el-col>
                  <el-col v-show="scope.row.rzzt==='1'"  :span="12"><a href="javascript:;" class="Danger" @click="changeRight('不通过',scope.row,scope.$index)">不通过</a></el-col>
                  <!--<el-col v-show="scope.row.rzzt==='2'" :span="12"><a href="javascript:;" class="Brand" @click="changeRight('授权',scope.row,scope.$index)">授权</a></el-col>-->
                  <!--<el-col v-show="scope.row.rzzt==='2'"  :span="12"><a href="javascript:;" class="Danger" @click="changeRight('不通过',scope.row,scope.$index)">不通过</a></el-col>-->
                  <el-col v-show="scope.row.rzzt==='2'"   :span="12"><a href="javascript:;" class="Brand" @click="changeRight('修改授权',scope.row,scope.$index)">修改授权</a></el-col>
                  <el-col v-show="scope.row.rzzt==='2'"  :span="12"><a href="javascript:;" class="Warning" @click="changeRight('撤销授权',scope.row,scope.$index)">撤销授权</a></el-col>
                  <!--<el-col v-show="scope.row.rzzt==='1'"   :span="12"><a href="javascript:;" class="Brand" @click="changeRight('修改授权',scope.row)">修改授权</a></el-col>
                  <el-col v-show="scope.row.rzzt==='1'"  :span="12"><a href="javascript:;" class="Warning" @click="changeRight('撤销授权',scope.row)">撤销授权</a></el-col>-->
                </el-row>
              </template>

              <!-- <a href="javascript:;" @click="changeRight('pass')">授权</a>
               <a href="javascript:;" @click="changeRight('disable')">不通过</a>
               <a href="javascript:;" @click="changeRight('change')">修改授权</a>
               <a href="javascript:;" @click="changeRight('revoke')">撤销授权</a>-->
            </el-table-column>
          </el-table>
          <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
            <el-form :model="curData" style="width: 530px; margin: auto;" :rules="rules" ref="curData">
              <el-form-item label="社会信用代码：" :label-width="formLabelWidth" class="width80">
                <p>{{ curData.nsrsbh }}</p>
              </el-form-item>
              <el-form-item label="企业名称：" :label-width="formLabelWidth" class="width80">
                <p>{{ curData.qymc }}</p>
              </el-form-item>
              <el-form-item label="资质等级：" :label-width="formLabelWidth" class="width80">
                <p>{{ curData.zzdj }}</p>
              </el-form-item>
              <div v-if="curEdit!=='不通过'&&curEdit!=='撤销授权'">
                <el-form-item label="可用项目(分期)数量：" :label-width="formLabelWidth" class="is-required width80" prop="MaxProjectCount">
                  <el-input style="width: 60px;" v-model.number="curData.MaxProjectCount" autocomplete="off"></el-input> 个
                </el-form-item>
                <el-form-item label="可用时长：" class="is-required" :label-width="formLabelWidth">
                  <el-radio-group v-model="form1.dayRadio" @change="removeErr('days')">
                    <el-radio label="一周"></el-radio>
                    <el-radio label="永久"></el-radio>
                    <el-radio label="自定义"></el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item  prop="days" ref="days" id="days" class="days" style=" min-width: 80px; width: 80px;">
                  <el-input style="width: 60px;" v-model.number="form1.days" autocomplete="off"></el-input> 天
                </el-form-item>
              </div>
              <el-form-item v-if="curEdit==='不通过'||curEdit==='撤销授权'" label="审核意见：" :label-width="formLabelWidth" class="is-required" prop="region" ref="region">
                <el-autocomplete
                  class="inline-input"
                  v-model="form1.region"
                  :fetch-suggestions="querySearch"
                  @select="handleSelect"
                  placeholder="请输入审核意见"
                ></el-autocomplete>
              </el-form-item>
              <!--<el-form-item v-if="curEdit==='撤销授权'" label="审核意见：" :label-width="formLabelWidth" class="is-required" prop="region" ref="region">
                <el-autocomplete
                  class="inline-input"
                  v-model="form1.region"
                  :fetch-suggestions="querySearch"
                  @select="handleSelect"
                  placeholder="请输入审核意见"
                ></el-autocomplete>
              </el-form-item>-->
            </el-form>
            <div slot="footer" class="dialog-footer">
              <!--<el-button @click="dialogFormVisible = false">取 消</el-button>-->
              <el-button v-show="curEdit!=='不通过'&&curEdit!=='撤销授权'"  type="primary" @click="editSubmit('curData')">确认授权</el-button>
              <el-button v-show="curEdit==='不通过'" type="warning" @click="Cancellation('curData')">审核不通过</el-button>
              <el-button v-show="curEdit==='撤销授权'" type="warning" @click="Cancellation('curData')">撤销授权</el-button>
            </div>
          </el-dialog>
        </template>

      </div>
      <div class="rzPage">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[1,10, 20, 30, 40,50,60,70,80,90,100]"
          :page-size="form.pagesize"
          :current-page.sync="form.pageindex"
          :pager-count="5"
          layout="prev, pager, next, total,sizes, jumper"
          :total="form.pageNum">
        </el-pagination>
      </div>
    </div>

    <!--<el-form :model="form" style="width: 530px; margin: auto;" :rules="rules" id="emilform" ref="emilform">
      <el-form-item label="邮箱：" :label-width="formLabelWidth" class="is-required width80" prop="emil">
        <el-input style="width: 60px;" v-model="emil" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>-->
    <el-dialog class="rzData emilBord" title="后台用户邀请" :visible.sync="dialogFormVisibleEmil">
      <el-form :model="emil" :rules="rules" ref="emil">
        <el-form-item label="邮箱：" :label-width="formLabelWidth" class="is-required" prop="url">
          <el-input class="emil" v-model="emil.url" autocomplete="off" placeholder="请输入邀请后台用户的邮箱"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisibleEmil = false">取 消</el-button>
        <el-button type="primary" @click="emilSave('emil')">确 定</el-button>
      </div>
    </el-dialog>
    <!--<viewer :images="images" class="imglist" ref="viewer">
      <img class="imgslist" v-for="src in images" :src="src.path" :key="" data-id="index" width="300" height="100">
    </viewer>-->
    <div class="images none" v-viewer="{movable: false}">
      <img v-for="src in images" :src="src.path" v-bind:key="src.id">
    </div>
  </div>

</template>


<script>
  // import 'viewerjs/dist/viewer.css'
  // import Viewer from "v-viewer/src/component.vue"
  import 'element-ui/lib/theme-chalk/index.css';
  export default {
    name: 'Authentication',
    data () {
      // 大于0
      let dayulig=(rule,value,callback)=>{
        let reg=/^[1-9]|[1-9][0-9]*$/;
        // console.log(value)
        console.log('大于0')
        // console.log(reg.test(value))
        console.log((value+'').length)
        if(!reg.test(value)||value<0){
          callback(new Error('必须为正数！'))
        }else if((value+'').length>7){
          callback(new Error('长度过长！'))
        }else{
          callback()
        }
      };
      let region=(rule,value,callback)=>{
        // console.log(value1)
        var value = this.form1.region
        var conStr = value.replace(/\s+/g,"");

        if(conStr.length<=0){
          callback(new Error('请输入审核意见'))
        }else if(conStr.length>50){
          callback(new Error('长度过长'))
        }else{
          callback()
        }
      };
      let shijian=(rule,value,callback)=>{
        console.log('时间校验')
        var that = this;
        if(that.form1.dayRadio==='自定义'){
          // that.curData.yxbzmc = that.form1.days
          dayulig(rule,that.form1.days,callback)
        }else{
          // that.curData.yxbzmc = that.form1.dayRadio
          callback()
        }
      };
      let shijianre=(rule,value,callback)=>{
        console.log('change')
        var that  =this;
        that.form1.days = '';
        console.log()
        this.$ref.days.blur();
      };
      let emilcheck=(rule,value,callback)=>{
        let reg=/[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/;
        console.log(value)
        // console.log(reg.test(value))
        if(!reg.test(value)){
          callback(new Error('邮箱格式不正确！'))
        }else{
          callback()
        }
      };
      return {
        images:[
        ],
        loading: true,
        urljump:this.$store.getters.getUrl,
        loginUrl:this.$store.getters.getloginUrl,
        // 查询条件
        form: {
          username:'',
          qymc:'',
          nsrsbh:'',
          sqlx:'',
          zzdj:'',
          rzzt:'',
          pagesize:50,
          pageindex:1,//
          pageNum:0
        },
        curData:{//当前操作行数据
          MaxProjectCount:''
        },
        shyjs:[{value:'合同编号不正确'},{value:'合同已到期'},{value:'资质等级不符合要求'},],
        curEdit:'',// 当前操作类型
        dialogTitle:'消息',
        dialogFormVisible: false,
        dialogFormVisibleEmil:false,
        formLabelWidth: '165px',
        tableData: [],
        emil:{
          url:''
        },
        zzdjCompare:{
          1:'A级',
          2:'AA级',
          3:'AAA级',
          4:'AAAA级',
          5:'AAAAA级'
        },
        rzztCompare:{
          0:'未认证',
          1:'待认证',
          2:'已认证',
          3:'未认证'
        },
        form1:{
          MaxProjectCount:'',
          days:'',
          dayRadio:'一周',
          region:''
        },
        rules: {
          region:[
            {validator:region, trigger: 'blur' }
          ],
          MaxProjectCount: [
            { required: true, message: '请输入可用项目(分期)数量', trigger: 'blur' },
            // { type: 'number', message: '数量必须为数字值' , trigger: 'blur'},
            {validator:dayulig,trigger:'blur'}
          ],
          days: [
            // { required: true, message: '请选择时间！', trigger: 'blur' },
            { validator:shijian,trigger:'blur'}
          ],
          dayRadio:[
            { validator:shijianre,trigger:'change'}
          ],
          url:[
            {validator:emilcheck,message:'邮箱格式不正确',trigger:'blur'}
          ]
        }
      }
    }
    , props: {

    }
    , methods: {
      //审核意见推荐
      querySearch(queryString, cb) {
        var restaurants = this.shyjs;
        var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        // 调用 callback 返回建议列表的数据
        cb(results);
      },
      handleSelect(item) {
        console.log(item);
        this.form1.region = item.value;
        this.$refs['region'].clearValidate();
      },
      createFilter(queryString) {
        return (restaurant) => {
          return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      // 发送邀请
      inviteSend:function(){
        this.emil.url = '';
        this.dialogFormVisibleEmil = true;
        if(this.$refs['emil']!==undefined){
          this.$refs['emil'].resetFields();
        }
      },
      emilSave:function(formName){
        var url = window.location.href.split('/#/')[0];
        console.log(url)
        url+='/#'+this.urljump
        let params={
          username:this.emil.url,
          url:url
          // url:'http://localhost:8080/#/activate'
        }
        console.log(params)
        var that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            // alert('submit!');
            this.$axios({
              method: 'post',
              url: 'UserManager/BackInvite',
              data: params
            })
              .then(res => {
                let data = res.data
                console.log(data)
                console.log(data.isError == 'False')
                if (data.isError == 'False') {//成功
                  // this.$message('请刷新页面后重试！');
                  this.$message(
                    {
                      message: data.errorMessage,
                      type: 'success'
                    }
                  );
                  that.dialogFormVisibleEmil = false
                } else {
                  this.$message(data.errorMessage);
                }

              })
              .catch(err => {
                that.$message.error('网络连接失败');
                window.location.href = that.$store.getters.getloginUrl
                // this.$store.commit('setDialogConfig', sendData)
              })
            //this.dialogFormVisible = false
          } else {
            console.log('error submit!!');
            // this.$message('请刷新页面后重试！');
            return false;
          }
        });

      },
      // 编辑操作
      changeRight:function(op,rowdata,index){
        // console.log(index)
        var that = this;
        // console.log(this.$refs)
        if (this.$refs['curData']!==undefined) {
          this.$refs['curData'].resetFields();
        }
        // this.$refs['curData'].clearValidate();

        /*this.form1 = { MaxProjectCount:'',
          days:'',
          dayRadio:'一周',
          region:''
        }*/
        this.form1.MaxProjectCount=  '';
        this.form1.days=  '';
        this.form1.dayRadio=  '一周';
        this.form1.region=  '';

        // this.curData = rowdata;

        for(var key in rowdata){
          this.curData[key] = rowdata[key]
        }

        this.curData['curIndex'] = index;
        if(rowdata.yxbzmc!='一周'&&rowdata.yxbzmc!='永久'){
          this.form1.dayRadio = '自定义';
          this.form1.days = rowdata.yxbzmc;
        }else{
          this.form1.dayRadio=rowdata.yxbzmc;
          this.form1.days = '';
        }
// console.log(rowdata.MaxProjectCount)
        this.form1.MaxProjectCount=rowdata.MaxProjectCount;
        console.log(this.form1)
        console.log(op,rowdata);

        var content = '';
        var htmlBool = false;
        var centerBool = false;
        this.curEdit = op;
        this.dialogTitle = op;
        switch(op){
          case '授权':
          case '修改授权':
          case '不通过':
          case '撤销授权':
            this.dialogFormVisible = true

            break;
          case '撤销授权1':
            content = '<h3 class="html-center">是否撤销授权？</h3>';
            this.$confirm(content, op, {
              distinguishCancelAndClose: true,
              dangerouslyUseHTMLString: true,
              confirmButtonText: '确认',
              cancelButtonText: '取消',
              // center: true
            })
              .then(() => {
                // this.$message({
                //   type: 'info',
                //   message: '保存修改'
                // });
                console.log(rowdata)
                let params = {
                  'nsrsbh':rowdata.nsrsbh,
                  'username':rowdata.username
                }
                this.$axios({
                  method: 'post',
                  url: 'UserManager/UnAuthorize',
                  data: params
                })
                  .then(res => {
                    let data = res.data
                    console.log(data)

                    if (data.isError == 'False') {
                      this.$message({
                        message: data.errorMessage,
                        type: 'success'
                      });
                      that.searchSubmit()
                    } else {
                      that.$message.error(data.errorMessage);
                    }
                  })
                  .catch(err => {
                    that.$message.error('网络连接失败');
                    // that.$message.error('网络连接失败');
                    window.location.href = that.$store.getters.getloginUrl
                    // this.$store.commit('setDialogConfig', sendData)
                  })
                //UnAuthorize
              })
              .catch(action => {
                // that.$message.error('请刷新页面后重试！');
                console.log('点击取消')
              });
            break;
        }
      },
      // 字段校验
      checkValues:function(){

      },
      // 查询提交
      searchSubmit:function(num){
        if(num!==undefined){
          this.form.pageindex = num;
        }
        var that = this;
        that.loading = true;
        console.log(this.form);
        let params = this.form;
        this.$axios({
          method: 'post',
          url: 'UserManager/GetListLRenZhengStatus',
          data: params
        })
          .then(res => {
            let data = res.data
            console.log(data)
            var pageNum = data.result[0].number;
            that.form.pageNum = pageNum;
            console.log('分页数：'+pageNum);
            if (data.isError == 'false') {
              var result = data.resultbg;
              for (let i = 0; i < result.length; i++) {
                result[i].zzdj = that.zzdjCompare[result[i].zzdj]
                // result[i].rzzt = that.rzztCompare[result[i].rzzt]
              }
              that.tableData = result;
            } else {
              that.tableData = [];
            }
            that.loading = false;
          })
          .catch(err => {
            that.$message.error('网络连接失败');
            window.location.href = that.$store.getters.getloginUrl
            // this.$store.commit('setDialogConfig', sendData)
          })
      },
      // 编辑提交
      editSubmit:function(formName){
        // console.log(this.curData);
//string nsrsbh,string username,string maxProjectCount,string yxspan
//         this.curData
        let params = {
          nsrsbh:this.curData.nsrsbh,
          username:this.curData.username,
          maxProjectCount:this.curData.MaxProjectCount,
          yxspan:this.form1.dayRadio==='自定义'?this.form1.days:this.form1.dayRadio,
          url:window.location.href
        };
        var that = this;
        // console.log(params);
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$axios({
              method: 'post',
              url: 'UserManager/Authorize',
              data: params
            })
              .then(res => {
                let data = res.data
                console.log(data)
                console.log(data.isError == 'False')
                if (data.isError == 'False') {
                  var result = data.resultbg;
                  that.curData.MaxProjectCount = params.maxProjectCount;
                  that.form1.MaxProjectCount  = params.maxProjectCount;
                  that.curData.yxbzmc = that.form1.dayRadio=='自定义'?that.form1.days:that.form1.dayRadio;
                  // console.log(that.form1)
                  // this.dialogFormVisible = false
                  that.tableData[that.curData['curIndex']] = that.curData
                  that.$set(that.tableData,that.curData['curIndex'],that.curData)
                  /*that.form1 = { MaxProjectCount:'',
                    days:'',
                    dayRadio:'一周',
                    region:''
                  }*/
                  that.form1.MaxProjectCount=  '';
                  that.form1.days=  '';
                  that.form1.dayRadio=  '一周';
                  that.form1.region=  '';
                  that.searchSubmit()
                  that.dialogFormVisible = false
                  that.$message({
                    message: data.errorMessage,
                    type: 'success'
                  });
                } else {
                  that.$message.error(data.errorMessage);
                }

              })
              .catch(err => {
                that.$message.error('网络连接失败');
                window.location.href = that.$store.getters.getloginUrl
                // this.$store.commit('setDialogConfig', sendData)
              })
            //this.dialogFormVisible = false
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      removeErr:function(name){
        console.log(name)
        this.form1.days='';
        this.$refs[name].clearValidate();
      },
      handleSizeChange:function(val) {
        console.log(`每页 ${val} 条`);
        this.form.pagesize = val;
        this.searchSubmit();
      },
      handleCurrentChange:function(val) {
        console.log(`当前页: ${val}`);
        this.form.pageindex = val;
        this.searchSubmit();
      },
      //不通过
      Cancellation:function(formName){
        //string rz_guid,string zt ,string bz,string sqlx="0"
        var that = this;
        let params = {
          rz_guid:this.curData.rz_guid,
          zt:'3',
          bz:this.form1.region,
          sqlx:this.curData.sqlx,
        };

        if(this.curEdit=='不通过'&&this.curData.rzsf=='试用用户'&&this.curData.sqlx==1){
          params['sqlx'] = 0;
          params['zt'] = 2;
        }

        console.log(params)
        // return;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            // alert('submit!');
            this.$axios({
              method: 'post',
              url: 'UserManager/Cancellation',
              data: params
            })
              .then(res => {
                let data = res.data
                console.log(data)
                console.log(data.isError == 'False')
                if (data.isError == 'False') {
                  // this.$message('请刷新页面后重试！');
                  // that.$message({
                  //   message: data.errorMessage,
                  //   type: 'success'
                  // });
                  that.$message({
                    message: data.errorMessage,
                    type: 'success'
                  });
                  that.searchSubmit()
                  that.dialogFormVisible = false;
                } else {
                  that.$message.error(data.errorMessage);
                }

              })
              .catch(err => {
                that.$message.error('网络连接失败');
                window.location.href = that.$store.getters.getloginUrl
                // this.$store.commit('setDialogConfig', sendData)
              })
            //this.dialogFormVisible = false
          } else {
            console.log('error submit!!');
            // this.$message('请刷新页面后重试！');
            return false;
          }
        });
        // this.dialogFormVisible = false;
        console.log(params)
      },
      getPiclist:function(zt,ob){
        console.log(zt,ob)
        let params = {
          'rz_guid':ob.rz_guid,
          'lx':zt
        }
        var that = this;
        // return;
        //GetFuJianList
        this.$axios({
          method: 'post',
          url: 'UserManager/GetFuJianList',
          data: params
        })
          .then(res => {
            let data = res.data
            console.log(data)
            if (data.isError == 'false') {

              // that.$message({
              //   message: data.errorMessage,
              //   type: 'success'
              // });
              that.images=data.result;
              console.log(that.images)

              that.$nextTick(function(){

                setTimeout(function(){
                  const viewer = that.$el.querySelector('.images').$viewer
                  viewer.show()
                },500);
              })

              // console.log(Viewer)
            } else {
              that.$message.error(data.errorMessage);
            }

          })
          .catch(err => {
            that.$message.error('网络连接失败');
            window.location.href = that.$store.getters.getloginUrl
            // this.$store.commit('setDialogConfig', sendData)
          })
      }
    }
    , watch: {
      dialogFormVisible(oldv,newv){
        console.log(oldv,newv)
        console.log(this.curData)
      }
    },
    mounted:function(){
      var loginUser = this.$route.query.name;
      console.log(this.$store._mutations.setLoginUser1)
      // this.$store._mutations.setLoginUser1(this.$store,loginUser)
      this.$store.getters.getLoginUser1.name = loginUser
      // var loginUser = this.$route.query.name;
      // this.$store.loginUser = loginUser
      // this.$store.commit('loginUser',loginUser);
      // this.$store._mutations.setLoginUser(this.$store,loginUser)
      console.log(this.$store)
    }
    , created () {
      this.searchSubmit();
      console.log(this)
    },
    components: {
    },
  }
</script>

<style>
  /* table {
     border-spacing: 0;
     border-collapse:separate;!* 如果值为collapse，则element表格下方会出现滚动条*!
   }*/
  /*.el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{border-left: 1px solid #EBEEF5;border-right: none}*/
  /*td:last-child,th:last-child{border-left: 1px solid #EBEEF5;}*/
  /*td:nth-child(11),th:nth-child(11){border-right: none;}*/
  .invite{ float: right; margin-right: 25px!important;font-size: 13px;
    color: #FFFFFF;
    letter-spacing: 1px}
  >>>#Authentication div{ overflow: inherit;}
  .width80{ width: 100%; min-width: 200px;}
  .head-center th,.html-center{ text-align: center;}
  .Brand{ color:#0779FF;}
  .Success{ color:#67C23A;}
  .Warning{ color:#E6A23C;}
  .Danger{ color:#F56C6C;}
  .content {

  }
  .content1 {
    width: 100%;
    background-color: #fff;
    height:calc(100% - 20px) !important;
    min-width: 1190px;
    max-width: 1200px;
    margin: 10px auto;
    overflow-x:hidden ;
  }
  #Authentication{ height:calc(100% - 235px); margin: auto; width: 100%;}
  #Authentication p{ padding: 0px; margin: 0px;}
  #Authentication .title {
    font-size: 24px;
    color: #2E2E2E;
    letter-spacing: 0;
    margin: 19px 0px 12px 24px;
  }

  #Authentication .title:before {
    content: '';
    position: relative;
    display: inline-block;
    font-size: 0;
    width: 6px;
    height: 20px;
    top: 2px;
    left: 0;
    margin-right: 13px;
    background: #04A4FF;
  }

  .line-gray {
    height: 1px;
    background: #EDEDED;
    margin: 0 24px;
  }
  .rzData .el-form-item,.rzForm .el-form-item{ display: inline-flex; margin-right: 12px; margin-bottom: 0px;} /*margin: auto !important;*/
  .rzForm .input-rz{
    width: 100px;
  }
  .rzForm .input-rz input{ padding: 0 10px !important;}
  .rzForm .el-form-item{ margin-bottom: 0px;}
  .rzForm .el-form-item label{ padding: 0px !important;font-size: 12px;}
  .rzForm .el-radio{ margin-right: 10px !important;}
  .rzForm .el-radio__label{ padding-left: 5px;}
  .rzForm{ padding-left: 25px;}
  .rzSearch{ width: 72px;}
  .rzData{ padding: 0px 25px; height:calc(100% - 172px);}
  /*.rzData thead,.rzData thead tr{background: #F9FBFF;}*/
  .rzData .el-table th,.rzData thead .el-table tr{background: #F9FBFF;color: #2E2E2E; font-weight: normal;
  }
  #Authentication .text-over{ white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 100%;}
  .rzData .el-table td,.rzData .el-table th{padding: 5px 0px;}
  #Authentication .el-message-box__title,.rzData .el-dialog__title{font-size: 14px;
    color: #929AAB;}
  #Authentication .el-message-box__header,.rzData .el-dialog__header{border-bottom: 1px solid #E2E2E2;}
  #Authentication  .el-message-box__btns{ text-align: center;}
  .rzData .el-form-item__content{ margin-left: 0px !important; min-width: 200px;}
  .days .el-form-item__content{min-width: 80px;}
  .rzData .dialog-footer{ text-align:center;}
  .rzData .el-form-item__label,.rzData .el-input__inner,.rzData .el-form-item__content,.rzData .el-input__icon{ height: 32px; line-height: 32px;}
  .rzData .el-dialog__header{ padding: 10px 20px;}
  .rzData .el-dialog__headerbtn{top:15px;}
  .rzPage{border: 1px solid #EBEEF5; margin: 0px 25px; border-top:none; padding: 5px 0px;}
  #Authentication .el-dialog{ height:auto; padding-bottom: 15px; max-width: 600px;}
  .emilContent{ padding: 20px 50px;}
  .emil{
    width: 200px; height: 32px; line-height: 32px; margin-left: 0px;}
  .el-form-item__content{ margin-left: 0px !important;}
  .emilBord{ width: 900px; margin: auto !important;}
  .emilBord .el-form-item__label{ width: 100px !important;}
  #Authentication .el-dialog__body{padding: 30px 20px !important;}
</style>



// WEBPACK FOOTER //
// src/components/Authentication.vue